module.exports = __webpack_public_path__ + "static/img/badge-adulticide-active.99bcc5e.svg";